var yellow = {
  100: '#FAF3EB',
  200: '#F9E6CF',
  300: '#F8DAB2',
  400: '#F6C377',
  500: '#F1AF40',
  600: '#E79C16',
  700: '#CD8600',
  800: '#7E5300',
  900: '#261A00'
};
export default yellow;